"use strict";
/**
 * Jira ticket parsing, shared by the services and the Command Console.
 *
 * Only what both runtimes need lives here. Nothing reads configuration: this is
 * bundled into the console, whose webpack build replaces the whole
 * `process.env` expression, so a read here would silently yield `undefined` in
 * the browser. The tenant is passed in instead.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.jiraTicketUrl = exports.jiraTicketKey = void 0;
/** A Jira issue key: project key, hyphen, issue number. */
const JIRA_KEY = /^[A-Z][A-Z0-9]*-\d+$/;
/** The issue key inside a Jira browse link, wherever the link came from. */
const JIRA_BROWSE_LINK = /\/browse\/([A-Za-z][A-Za-z0-9]*-\d+)\b/;
function isJiraTicketKey(value) {
    return JIRA_KEY.test(value.trim().toUpperCase());
}
/**
 * The storable form of a ticket an operator typed or pasted.
 *
 * Takes a bare key or a browse link and returns the key, upper-cased so two
 * people entering it differently store the same string. Host-agnostic, so it
 * survives a tenant move.
 *
 * Null for anything not reducible to a key — there is no lenient path.
 */
function jiraTicketKey(value) {
    const trimmed = value.trim();
    const link = JIRA_BROWSE_LINK.exec(trimmed);
    if (link)
        return link[1].toUpperCase();
    return isJiraTicketKey(trimmed) ? trimmed.toUpperCase() : null;
}
exports.jiraTicketKey = jiraTicketKey;
/**
 * Where to send someone who clicks a ticket.
 *
 * Undefined for free text, and for an absent `tenantUrl` — a link to
 * `undefined/browse/OPS-336` is worse than none.
 */
function jiraTicketUrl(ticket, tenantUrl) {
    const trimmed = ticket.trim();
    const tenant = tenantUrl?.trim().replace(/\/+$/, "");
    if (!tenant || !isJiraTicketKey(trimmed))
        return undefined;
    return `${tenant}/browse/${trimmed.toUpperCase()}`;
}
exports.jiraTicketUrl = jiraTicketUrl;
